import Exception from './Exception';
/**
 * Custom Error class of type Exception.
 */
class IllegalStateException extends Exception {
}
IllegalStateException.kind = 'IllegalStateException';
export default IllegalStateException;
